import mapJson from 'jsonpath-mapper';
import { MigrateOperations, MigrateRequest } from '~/services';

const formatResult = {
  $formatting: (res: any) => {
    return typeof res === 'string' ? res : res.source;
  },
};

export const mapPayloadToMigrateOperations = (
  payload: MigrateRequest,
  operation: 'migrate' | 'duplicate' | 'delete' = 'migrate'
): MigrateOperations => {
  return mapJson(payload, {
    contentTypes: {
      $path: [`${operation}.contentTypes`, 'contentTypes'],
      ...formatResult,
    },
    components: {
      $path: [`${operation}.components`, 'components'],
      ...formatResult,
    },
    models: [`${operation}.models`, 'models'],
    duplicate: {
      components: 'duplicate.components[*].source',
      contentTypes: 'duplicate.contentTypes[*].source',
      models: 'duplicate.models[*]',
      combined: 'duplicate.[*].source',
    },
    migrate: {
      components: 'migrate.components',
      contentTypes: 'migrate.contentTypes',
      models: ['migrate.models', 'models'],
      combined: 'migrate..*',
    },
  });
};
